import React, { useEffect } from 'react'

import Lock from '../Assets/Lock.gif'
import './Styles/Lockout.scss'

import {Link} from 'react-router-dom'

const Lockout = () => {

  const Open_Signup = true;
  return (
    <>
    {Open_Signup ? 

    <div>
      {/* Fix later with actual signup form */}
      {window.location.href = 'https://www.eventcreate.com/e/robocamp2025'}
    </div> :

    <div className='lockout'>
      <div className='wrapper'>
        <h1><span class='red'>SIGNUPS ARE CURRENTLY CLOSED, CHECK BACK IN THE SPRNG OF 2026</span></h1>
        <hr></hr>
        <h2>RoboCamp will start sometime in June of 2026.</h2>
        <p>Sign up on our hosting partner's website (EventCreate) using the link below!</p>
        <a href="https://www.eventcreate.com/e/robocamp2025">Click here to sign up now!</a>
      </div>
    </div>
    
    }
    </>
  )
}

export default Lockout
